export const RPC_SERVER_RUNNING = 'RPC_SERVER_RUNNING';

export default {
  RPC_SERVER_RUNNING,
};
